import { useMemo } from 'react'
import { useSelector } from 'react-redux'

function useNameStyle(name = ' ') {
  const event = useSelector(state => state.event.event)
  return useMemo(() => {
    if (event.live_settings.name_style) {
      if (event.live_settings.name_style === 'full_name') {
        return name
      } else if (event.live_settings.name_style === 'first_name') {
        return name ? name.split(' ')[0] : ''
      } else if (event.live_settings.name_style === 'paddle_number') {
        return 'paddle_number'
      } else {
        return 'Anonymous'
      }
    } else {
      return ''
    }
  }, [name, event.live_settings.name_style])
}

export default useNameStyle



// WEBPACK FOOTER //
// ./src/hooks/useNameStyle.js